"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_FONTS_VERSION = exports.DEFAULT_FAVICON_VERSION = void 0;
/** Supported version of favicon included in AppShell pages */
const DEFAULT_FAVICON_VERSION = exports.DEFAULT_FAVICON_VERSION = 1;

/** Supported version of fonts included in AppShell pages */
const DEFAULT_FONTS_VERSION = exports.DEFAULT_FONTS_VERSION = 2;
